<script lang="ts" setup>
const props = defineProps <{
  items: {
    key: string
    name: string
  }[]
  placeholder?: string
}>()

const model = defineModel<string | undefined>({ required: true })
</script>

<template>
  <RadixSelectRoot v-model="model" class="relative">
    <div class="relative">
      <RadixSelectTrigger
        v-bind="$attrs"
        class="h-4.8rem min-w-16rem inline-flex items-center justify-between gap-.5rem bg-#1C2330 px-1.5rem text-1.3rem leading-none ring-0 ring-starline-primary transition data-[placeholder]:text-neutral-white"
      >
        <RadixSelectValue :placeholder="props.placeholder" :class="model === undefined ? 'text-neutral-white/40' : 'text-neutral-white'" />
        <div v-if="!model" class="i-radix-icons-arrow-down size-1.6rem" />
      </RadixSelectTrigger>
      <button v-if="model" aria-label="clear selection" class="absolute inset-y-0 right-0 px-1.5rem hover:bg-neutral-black/20" @click="model = undefined">
        <div class="i-radix-icons-cross-1 size-1.6rem" />
      </button>
    </div>

    <RadixSelectPortal>
      <RadixSelectContent
        class="z-[100] min-w-[160px] border border-neutral-darkGray bg-starline-secondary"
        :side-offset="5"
      >
        <RadixSelectScrollUpButton class="h-[25px] flex cursor-default items-center justify-center border-b border-neutral-darkGray">
          <div class="i-radix-icons-chevron-up" />
        </RadixSelectScrollUpButton>

        <RadixSelectViewport class="p-.5rem">
          <RadixSelectItem
            v-for="(option, index) in props.items"
            :key="index"
            class="relative h-4rem flex select-none items-center pl-2.5rem pr-3.5rem text-1.3rem leading-none ring ring-0 ring-starline-primary data-[disabled]:pointer-events-none data-[disabled]:text-opacity-50 data-[highlighted]:shadow-starline data-[highlighted]:outline-none data-[highlighted]:ring-1"
            :value="option.key"
          >
            <RadixSelectItemIndicator class="absolute left-0 w-[25px] inline-flex items-center justify-center">
              <div class="i-radix-icons-check" />
            </RadixSelectItemIndicator>
            <RadixSelectItemText>
              {{ option.name }}
            </RadixSelectItemText>
          </RadixSelectItem>
        </RadixSelectViewport>

        <RadixSelectScrollDownButton class="h-[25px] flex cursor-default items-center justify-center border-t border-neutral-darkGray">
          <div class="i-radix-icons-chevron-down" />
        </RadixSelectScrollDownButton>
      </RadixSelectContent>
    </RadixSelectPortal>
  </RadixSelectRoot>
</template>

<style scoped>
</style>
